// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
  width: 100%;
  height: 100%;
  padding: 20px 32px;
  background-color: #fff;
}

.superior {
  width: 100%;
  height: 25%;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.superior h2 {
  color: #362166;
  font-size: 24px;
  margin-top: 0;
  padding: 0px;
  margin-bottom: 30px;
}

.cerrar mat-icon {
  cursor: pointer;
  margin-top: 5px;
}

.footer {
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 12px;
}

.deshabilitar {
  cursor: nw-resize;
  color: #666666;
  pointer-events: none;
}

.footer-advertencia {
  text-align: center;
  margin-top: 8px;
}

.dragndrop-container {
  height: 200px;
  border: 1px solid rgba(0, 32, 173, 0.231372549);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.dragndrop-container input[type=file] {
  display: none;
}

.form-column {
  display: flex;
  flex-direction: column;
  padding-top: 16px;
}

input[hidden] {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/dialogs/subir-manuales/subir-manuales.component.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AADJ;;AAIA;EACI,WAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;AADJ;;AAIA;EACI,cAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;AADJ;;AAIA;EACI,eAAA;EACA,eAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,iBAAA;EACA,cAAA;EACA,oBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,eAAA;AADJ;;AAIA;EACI,aAAA;EACA,+CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,aAAA;AADJ;;AAIA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,wBAAA;AADJ","sourcesContent":["\r\n\r\n.main-container{\r\n    width: 100%;\r\n    height: 100%;\r\n    padding: 20px 32px;\r\n    background-color: #fff;\r\n}\r\n\r\n.superior {\r\n    width: 100%;\r\n    height: 25%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: baseline;\r\n}\r\n\r\n.superior h2 {\r\n    color: #362166;\r\n    font-size: 24px;\r\n    margin-top: 0;\r\n    padding: 0px;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.cerrar mat-icon{\r\n    cursor: pointer;\r\n    margin-top: 5px;\r\n}\r\n\r\n.footer{\r\n    width: 100%;\r\n    height: 32px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding-top: 12px;\r\n}\r\n\r\n.deshabilitar{\r\n    cursor: nw-resize;\r\n    color: #666666;\r\n    pointer-events:none;\r\n}\r\n\r\n.footer-advertencia {\r\n    text-align: center;\r\n    margin-top: 8px;\r\n}\r\n\r\n.dragndrop-container{\r\n    height: 200px;\r\n    border: 1px solid #0020ad3b;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    text-align: center;\r\n}\r\n\r\n.dragndrop-container input[type=\"file\"]{\r\n    display: none;\r\n}\r\n\r\n.form-column {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding-top: 16px;\r\n}\r\n\r\ninput[hidden] {\r\n    display: none !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
